import Vue from 'vue'
import App from './App.vue'

import '@css/index.css'

import store from './store'
import router from './router'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)
import 'default-passive-events'

Vue.config.productionTip = false

import common from '@/utils/common'
Vue.prototype.$common = common;

// 引入指令
import directive from '@/utils/directive';
Vue.use(directive)

import { dialogDrag } from '@/utils/dialogDrag'
Vue.directive('dialogDrag', dialogDrag)

import './utils/flexible.js'

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')
